<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import PolicyForm from "../../../components/latenessdeduction/policy/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": PolicyForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('latenessdeduction.createpolicy'),
      pageTitleValue: "",
      formData: {
        id: null,
        policydetail: [],

        latenessparamcode: null,
        latenessparamdesc: null,
        fromdate: null,
        todate: null,
        dedtpayitemid: null,
        currencyid: null,
        frequencyid: null,
        remark: null,

        payitemcode: null,
        payitemdesc: null,
        currencycode: null,
        currencydesc: null,
        frequencycode: null,
        frequencydesc: null,
        frequencyfactor: null,

        stamp: 0,
        userid: this.$store.getters.userId,
      },


      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      if (this.formData.clmviapayroll == true && this.formData.payitemid == null) {
        this.$dialog.alert(this.$t('payitemtoreimburseviapayroll')).then((dialog) => {
          console.log(dialog); 
        });
      } else {
     
      // console.log('form new', payload: this.formData})

      this.$store.dispatch('post', {url: "/latenessdeductionpolicy/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "latenessdeductionpolicylist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    }
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "latenessdeductionpolicylist" });
    },
  },
};
</script>